export default {
  towStoreDialog: {
    title: 'Tow Store Dispatch',
    description: 'I see you are dispatching a Tow Store (TS). Can you please add the provider\'s lot address.',
    addressLabel: 'Address',
    addressPlaceholder: 'Enter provider\'s lot address',
    phoneLabel: 'Provider\'s Phone Number',
    phonePlaceholder: '(555) 123-4567',
    submit: 'Submit',
    closeAriaLabel: 'close',
    addressNotFound: 'We couldn\'t find a Google address for the selected provider. You may need to enter it manually.'
  }
};
